export default "__VITE_ASSET__CJxe$J9g__"